// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"37e90fab","85":"b48c45be","151":"4255aa4f","377":"d71c22c5","493":"5e3818b2","734":"7ed7f559","816":"f7db24bc","836":"6a309427"}[chunkId] + ".chunk.js";
};